export default __webpack_public_path__ + "static/media/miguel-lopes-5.bde1414a.jpg";